import './style.scss';
import $ from 'jquery';
import gsap from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

function fadeInFunction() {
	if($(".wp-block-thanxblocks-scroll-anim.anim-f-in").length) {
		$(".wp-block-thanxblocks-scroll-anim.anim-f-in").each(function() {
			var self = $(this);
			
		    var tl = gsap.to(self,{duration:0.3,autoAlpha:1});
			var st = ScrollTrigger.create({
				trigger: self,
				start: "+=100 bottom",
				// markers: {startColor: "blue", endColor: "yellow", indent: 100},
				animation: tl
			});
		});
	}
}
fadeInFunction();

function revealFunction() {
	if($(".wp-block-thanxblocks-scroll-anim.anim-reveal").length) {
		$(".wp-block-thanxblocks-scroll-anim.anim-reveal").each(function() {
			var self = $(this),
				inner = self.find(".wp-block-thanxblocks-scroll-anim__inner");
			
		    var tl = gsap.timeline({paused:true})
		    .fromTo(self, {xPercent:-100},{duration:0.6,xPercent:0})
		    .fromTo(inner, {xPercent:100},{duration:0.6,xPercent:0}, "<");

			var st = ScrollTrigger.create({
				trigger: self,
				start: "+=100 bottom",
				// markers: {startColor: "blue", endColor: "yellow", indent: 100},
				animation: tl
			});
		});
	}
}
revealFunction();